import { Circle, Flex, Text, type FlexProps } from 'components'

interface BadgeProps extends Omit<FlexProps, 'children'> {
  iconVisible?: boolean
  text: keyof typeof statusBadgeStyles | string
}

export default function StatusBadge({ text, iconVisible, ...rest }: BadgeProps) {
  return (
    <Flex
      bg={statusBadgeStyles[text as keyof typeof statusBadgeStyles]?.bg}
      minW={75}
      maxW={80}
      h="37px"
      borderRadius="200px"
      boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.05)"
      backdropFilter="blur(27px)"
      align="center"
      justify="center"
      gap={1}
      p={3}
      {...rest}
    >
      <Flex>
        {iconVisible && (
          <Circle
            size="15px"
            bg="rgba(255, 255, 255, 0.27)"
            animation="livePulse"
          >
            <Circle size="5px" bg="white"></Circle>
          </Circle>
        )}
      </Flex>
      <Text textStyle="bodySmall" color="white">
        {text}
      </Text>
    </Flex>
  )
}

export const statusBadgeStyles = {
  Live: {
    bg: 'rgba(30, 166, 68, 1)',
  },
  Upcoming: {
    bg: 'yellow.600',
  },
  Past: {
    bg: 'gray',
  },
}
